<template v-if="order && order.status === 'finished'">
  <div>
    <layout-default :hide-footer-mobile="true">
      <br />  <br />

      <div class="full-order">
        <div class="pdv-container">
          <div class="custom-padding">

            <div class="program-title" v-if="students.length > 0">
              <div
                v-if="isEsencial(programSelectedTitle())"
                class="plan-selected-title"
                :class="{
                  'plan-selected-title-red':
                    programSelectedTitle() === 'Tradicional PSU 4° Medio',
                  'plan-selected-title-purple':
                    programSelectedTitle() === 'Academia PSU Egresados'
                }"
              >
                <div class="border-ecesnsial">
                  <div class="border1"></div>
                  <div class="border2"></div>
                </div>
                <div class="d-flex flex-col ml-2">
                  <span>PROGRAMA</span>
                  <h2>{{ programSelectedTitle() }}</h2>
                </div>
              </div>

              <div
                v-else
                :style="{borderLeft: '8px solid ' + getBorderTop(programSelectedTitle()) }"
                class="plan-selected-title"
                :class="{
                  'plan-selected-title-red':
                    programSelectedTitle() === 'Tradicional PSU 4° Medio',
                  'plan-selected-title-purple':
                    programSelectedTitle() === 'Academia PSU Egresados'
                }"
              >
                <span>PROGRAMA</span>
                <h2>{{ programSelectedTitle() }}</h2>
              </div>
            </div>

            <div class="seccion-separator"></div>

            <div class="div-alinear md-5 relative">
              <div class="item">

                <div class="exito">
                  <img src="/images/featured/tick-circle-bold.svg" class="" alt="icon-primero" />
                  <div class="texto">
                    <h6>Tu compra se realizó correctamente</h6>
                    <p>El comprobante de tu compra y la información de pago se enviaron a tu correo <span>{{ financingPartyEmail }}</span></p>
                  </div>
                </div>
                <div class="seccion-separator"></div>
                <h2 class="title">Información de tu compra</h2>

                <div class="card-summary">

                  <div
                    class="body"
                    v-for="(student, index) in students"
                    :key="index"
                  >
                    <div class="item">
                      <span>Programa</span>
                      <p>{{ student.program.name }}</p>
                    </div>
                    <div class="item">
                      <span>Nombre del estudiante</span>
                      <p>{{ student.name + " " + student.fatherLastName }}</p>
                    </div>
                    <div class="item" v-if="student.selectedLocation.address !== '-'" >
                      <span>Sede</span>
                      <p v-if="student.selectedLocation">{{ student.selectedLocation.address }}</p>
                    </div>
                    <div class="heading-info">
                      <span>Cursos</span>
                    </div>
                    <div
                      v-for="(course, index) in student.selectedCourses"
                      class="item"
                      :key="index"
                    >
                      <span v-if="course.hour">
                        {{ course.subjectName }} {{ course.coursePdvCode }}
                      </span>
                      <span v-else>
                        {{ selectedPack ? course.subjectName :  course.Subject.name }} {{  selectedPack ?   course.coursePdvCode : course.pdvCode }}
                      </span>
                      <p v-if="course.hour">{{ getSchedule(course.hoursPerDay) }}</p>
                    </div>
                    <div class="punteadas"></div>

                    <div class="item-price mb-2" v-if="student.prices && !selectedPack" >
                      <span class="text-total-courses" id="precio-bruto-ec">Precio bruto</span>
                      <span  class="value-total-courses" v-if="student.prices.precioBruto">
                        {{student.prices.precioBruto | moneyFormatter}}
                      </span>
                    </div>
                    <div class="item-price mb-2" v-if="student.prices && !selectedPack" >
                      <span class="text-discount">Descuento por sesiones</span>
                      <span class="value-discount" v-if="student.prices.valorDescuentoSesiones">
                        {{ student.prices.valorDescuentoSesiones | moneyFormatter}}
                      </span>
                    </div>
                    
                    <div class="item-price mb-2" v-if="student.prices && !selectedPack" >
                      <span class="text-total-courses">Total cursos</span>
                      <span  class="value-total-courses" v-if="student.prices">
                        {{student.prices.precioSubTotal | moneyFormatter}}
                      </span>
                    </div>
                    <div class="item-price mb-2" v-if="student.prices && !selectedPack" >
                      <span class="text-discount">Descuento</span>
                      <span class="value-discount" v-if="student.prices">
                        {{student.prices.valorDescuento | moneyFormatter}}
                      </span>
                    </div>
                    <div class="item-price mb-2" v-if="student.prices && !selectedPack" >
                      <span class="text-discount">Matrícula online</span>
                      <span class="value-discount" v-if="student.prices">{{ student.prices.valorMatricula | moneyFormatter }}</span>
                    </div>
                    <div class="item-price mb-2" v-if="order.coupon" >
                      <span class="text-discount">Descuento cupón ({{ order.coupon }})</span>
                      <span class="value-discount">{{ order.valueCoupon | moneyFormatter }}</span>
                    </div>
                    <div class="recta"></div>
                    <div class="item-price">
                      <span class="text-total">Monto Programa</span>
                      <span class="value-total">{{ total | moneyFormatter }}</span>
                    </div>

                  </div>
                </div>

                <div class="seccion-separator"></div>
                <h2 class="title">Información de pago</h2>

                <div class="card-summary">
                  <div class="body" v-if="order">
                    <div class="item">
                      <span>N° Orden de pedido</span>
                      <p>{{ order.buyOrder }}</p>
                    </div>
                    <div class="item">
                      <span>Nombre del comercio</span>
                      <p>Pre-Universitario Pedro de Valdivia S.A.</p>
                    </div>
                    <div class="item">
                      <span>Monto y moneda</span>
                      <p>{{ order.total | moneyFormatter }}</p>
                    </div>
                    <div class="item" v-if="order.total == 0">
                      <span>Código de cupón</span>
                      <p>{{ order.coupon }}</p>
                    </div>
                    <div class="item" v-if="order.total == 0">
                      <span>Descuento aplicado</span>
                      <p>100%</p>
                    </div>
                    <div class="item" v-if="order.total > 0">
                      <span>Cod. Aut. Transbank</span>
                      <p>{{ order.webPayAuthorizationCode  }}</p>
                    </div>
                    <div class="item">
                      <span>Fecha de transacción</span>
                      <p>{{ order.createdAt }}</p>
                    </div>

                    <div class="item" v-if="order.total > 0">
                      <span>Tipo de pago realizado</span>
                      <p>
                        {{order.webPayPaymentTypeCode === "VD" ? "Debito": "Crédito"}}
                      </p>
                    </div>
                    <div class="item" v-if="order.total > 0">
                      <span>Tipo de cuota</span>
                      <p v-if="order.webPaySharesNumber != 0">Con cuotas</p>
                      <p v-else>Sin cuotas</p>
                    </div>
                    <div
                      v-if="order.total > 0 && order.webPaySharesNumber != 0"
                      class="item"
                    >
                      <span>Nº de cuotas</span>
                      <p>{{ order.webPaySharesNumber }}</p>
                    </div>

                    <div class="item" v-if="order.total > 0" >
                      <span>4 últimos dígitos de la tarjeta bancaria</span>
                      <p>************ {{ order.webPayCardNumber }}</p>  
                    </div>

                    <div class="item">
                      <span>Descripción de los bienes y/o servicios</span>
                      <p>Programas PAES</p>
                    </div>
                  </div>
                </div>

              </div>
              <div class="item">

                <div class="total-grey">
                  <span class="key">Total Pagado</span>
                  <span class="value">{{ total | moneyFormatter }}</span>
                </div>

                <!-- <div class="links">
                  <div class="link mb-4">
                    <img src="/images/featured/document-download-morado.svg" alt="dwPdf" />  
                    <a 
                      href="#"
                      @click.prevent="downloadPdf"
                    >
                      Descargar como PDF
                    </a> 
                  </div>
                  <div class="link mb-4">
                    <img src="/images/featured/document-download-morado.svg" alt="dwPdf" />  
                    <a
                      href="#"
                      @click.prevent="ruleBook"
                    >
                      Descargar Reglamento PDF
                    </a> 
                  </div>
                  <div class="link mb-4">
                    <img src="/images/featured/sms-morado.svg" alt="sms" />  
                    <a 
                      href="#"
                      @click.prevent="resendEmail"
                    >
                      Enviar por email
                    </a> 
                  </div>
                  <div class="link">
                    <img src="/images/featured/printer.svg" alt="printer" />
                    <a 
                      href="#"
                      @click.prevent="printPdf"
                    >
                      Imprimir
                    </a> 
                  </div>
                </div> -->

                <div class="content-button">
                  <form @submit.prevent="goToNextStep">
                    <button type="submit" class="boton-new-primario boton-new-mediano w-full">
                      Ir a tu PDV
                    </button>
                  </form>
                </div>
                
              </div>
            </div>
          </div> 
        </div> 
      </div> 
    </layout-default>
    <div
      class="overlay-white"
      :class="{ 'd-none': order && order.status === 'finished' }"
    ></div>
  </div>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import StepsHeader from "@/components/StepsHeader";
import { orderBy } from "@/helpers";
import formValidation from "@/mixins/formValidation";

export default {
  components: {
    LayoutDefault,
    StepsHeader
  },
  data() {
    return {
      total: null,
      order: null,
      resendLoading: false,
      discount: null,
      serverPath: process.env.VUE_APP_API_URL
    };
  },

  computed: {
    ruleBook() {
      return process.env.VUE_APP_PDV_RULEBOOK;
    },

    formFinancingParty() {
      return {
        ...this.$store.state.financingParty
      };
    },
    financingPartyName() {
      return `${this.$store.state.financingParty.name} ${this.$store.state.financingParty.lastName}`;
    },
    financingPartyRut() {
      return this.$store.state.financingParty.rut;
    },
    financingPartyEmail() {
      return this.$store.state.financingParty.email;
    },
    financingPartyRegion() {
      if (!this.$store.state.financingParty.Region) return undefined;
      return this.$store.state.financingParty.Commune.Region.name;
    },
    financingPartyCity() {
      if (!this.$store.state.financingParty.City) return undefined;
      return this.$store.state.financingParty.City.name;
    },
    financingPartyCommune() {
      if (!this.$store.state.financingParty.Commune) return undefined;
      return this.$store.state.financingParty.Commune.name;
    },
    students() {
      return this.$store.state.students;
    },

    financingParty() {
      return this.$store.state.financingParty;
    },
    selectedPack(){
      return JSON.parse(localStorage.getItem('pack'));
    }
  },

  mixins: [formValidation],

  methods: {
    goToNextStep() {
      this.$router.push({ name: "SuccessInscription" });
    },
    programSelectedTitle() {
      if(this.students.length > 0){
        return this.students[0].program.name;
      } else {
        return ''
      }
    },
    setTotal() {
      if(this.selectedPack){
        this.total = this.selectedPack.priceOfert;
      } else {
        this.total = this.$store.state.students
        .map(student => student.prices.precioTotal)
        .reduce((previousValue, currentValue) => previousValue + currentValue);
      }
    },
    getSchedule(hoursPerDay){
      let days=""
      if (hoursPerDay.length == 1) {
        days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
      } else if (hoursPerDay.length == 2) {
        if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else {
          days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3)
        }
      } else if (hoursPerDay.length == 3) {
        if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[2].startTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[2].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3)
        } else if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[2].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[2].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[1].startTime.slice(0, -3)) {
          days = hoursPerDay[0].day + " y " + hoursPerDay[2].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + " y " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3)
        } else if (hoursPerDay[2].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[2].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) != hoursPerDay[2].startTime.slice(0, -3)) {
          days = hoursPerDay[2].day + " y " + hoursPerDay[1].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3) + " y " + hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else if (hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[1].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[1].endTime.slice(0, -3) && hoursPerDay[0].startTime.slice(0, -3) == hoursPerDay[2].startTime.slice(0, -3) && hoursPerDay[0].endTime.slice(0, -3) == hoursPerDay[2].endTime.slice(0, -3)) {
          days = hoursPerDay[0].day + ", " + hoursPerDay[1].day +  " y " + hoursPerDay[2].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3)
        } else {
          days = hoursPerDay[0].day + " " + hoursPerDay[0].startTime.slice(0, -3) + " a " +hoursPerDay[0].endTime.slice(0, -3) + ", " + hoursPerDay[1].day + " " + hoursPerDay[1].startTime.slice(0, -3) + " a " +hoursPerDay[1].endTime.slice(0, -3) + " y " + hoursPerDay[2].day + " " + hoursPerDay[2].startTime.slice(0, -3) + " a " +hoursPerDay[2].endTime.slice(0, -3)
        }
      }
      return days
    },
    printPdf(e) {
      window.open(`/comprobante/${this.order.buyOrder}`, "_blank");
    },
    downloadPdf() {
      window.open(
        `${this.serverPath}/tools/comprobante-compra?buyorder=${this.order.buyOrder}&isDownload=1`,
        "_self"
      );
    },
    async resendEmail() {
      this.resendLoading = true;
      const { data } = await this.Axios.post("/resend", {
        order: this.order.buyOrder
      });
      if (data.success) {
        alert(`Se ha reenviado el email a ${this.financingPartyEmail}`);
      } else {
        alert(`Ha ocurrido un problema al intentar reenviar el email`);
      }
      setTimeout(() => {
        this.resendLoading = false;
      }, 1000);
    },
    getBorderTopOld(e) {
      if(!e) {
        return ''
      }
      e = e.toLowerCase() 
      if(e.includes('tradicional')) {
        return '#AE4239'
      }else if(e.includes('pdvx')) {
        return '#FFD100'
      }else if(e.includes('pdv online')){
        return '#592466'
      }else if(e.includes('mentoring') || e.includes('esencial')){
        return '#5E9C3D'
      }else {
        return '#b6b6b6'
      }
    },
    getBorderTop(f) {
      let e;
      const data = this.$store.state.formatProgramName
      if(!data || data.nivel2 == '') {
        return ''
      } else {
        e = data.nivel2.toLowerCase();
        if(e.includes('tradicional')) {
          return '#AE4239'
        }else if(e.includes('pdvx')) {
          return '#FFD100'
        }else if(e.includes('pdv online') || e.includes('online') ){
          return '#592466'
        }else if(e.includes('mentoring') || e.includes('esencial')){
          return '#5E9C3D'
        }else {
          return '#b6b6b6'
        }
      }
    },
    isEsencial(e){
      if(!e) {
        return false
      }
      e = e.toLowerCase() 
      return (e.includes('mentoring') || e.includes('esencial'))
    }
  },

  async created() {
    this.Axios.get("/dashadmin/infogeneral").then(response => {
      this.discount = response.data[0].discount;
    });
    const { data: regions } = await this.Axios.get("/regions");
    this.availableRegions = orderBy([...regions], "name");
    // todo: limpiar location.search
    this.Axios.get("/orders" + window.location.search).then(async response => {
      console.log(response.data);
      this.order = response.data;
      if (response.data.status === "finished") {
        //this.$router.push({name: 'SuccessInscription'});
      }
      await this.$store.dispatch("setOrderInfo", response.data);

      await this.$store.dispatch(
        "addFinancingPartyInfo",
        response.data.FinancingParty
      );

      await this.$store.dispatch(
        "addCaretakerInfo",
        response.data.OrderDetails[0].Student.Caretaker
      );

      this.$store
        .dispatch("setStudents", response.data.sessionState.students)
        .then(() => {
          this.setTotal();
        });
    });
  },

  mounted() {
    
  },
  destroyed() {
    localStorage.clear();
  },
  beforeDestroy() {
    localStorage.clear();
  },
};
</script>

<style scoped lang="scss">

.plan-selected-title {
  padding-left: 8px;
  span {
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: $neutral70;
  }
  h2 {
    font-family: 'Poppins-Bold', sans-serif;
    font-size: 27;
    line-height: 37px;
    margin-bottom: 0;
    /*text-transform: uppercase;*/
    color: $neutralBlack;
    @media screen and (max-width: 768px) {
     
    }
    @media screen and (min-width: 769px) {
     
    }
  }
  &.plan-selected-title-red {
    span {
      background: $red-light;
    }

    h2 {
      color: $red-2-light;
    }
  }

  &.plan-selected-title-purple {
    span {
      background: $purple-light;
    }

    h2 {
      color: $purple;
    }
  }
}

  .full-order{

    @media (max-width: 768px) {
      margin-bottom: 24px;
    }
    @media (min-width: 769px) {
      margin-bottom: 32px;
    }


    .exito{
      display: flex;
      padding: 12px 16px;
      align-items: flex-start;
      gap: 12px;
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid  #4EEE9E;
      background: #F0FFF7;
      .texto{
        display: flex;
        flex-direction: column;

        h6{
          font-family: 'Poppins-Medium', sans-serif;
          color: #0F8047;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px; 
        }
        p{
          color: #0F8047;
          font-family: 'Poppins-Medium', sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          margin-bottom: 0;
          span{
            font-family: 'Poppins-Bold', sans-serif;
          }
        }
      }

      
    }

    .title{
      color: $neutralBlack !important;
      font-family: 'Poppins-Bold', sans-serif;
      font-style: normal;
      font-weight: 700;
        
      @media (max-width: 768px) {
        font-size: 18px;
        line-height: 26px;
      }
      @media (min-width: 769px) {
        font-size: 32px;
        line-height: 42px;
      }

    }

    .card-summary {
      display: flex;
      padding: 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 24px;
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid $neutralBlack;

      .body{
        display: flex;
        flex-direction: column;
        width: 100%;

        .item{
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-bottom: 12px;

          &:last-of-type {
            margin-bottom: 0;
          }



          span{
            color: $neutral70;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; 
          }
          p{
            color: $neutralBlack;
            font-family: 'Poppins-Medium', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            margin-bottom: 0;
          }
        }

        .heading-info{
          margin-bottom: 12px;
          width: 100%;
          display: flex;
          span{
            color: $neutral70;
            font-family: 'Poppins-Bold', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px; 
          }
        }

        .punteadas{
          margin: 24px 0;
          width: 100%;
          border: 1px dashed #CACBCE;
        }
        .item-price{
          width: 100%;
          display: flex;
          justify-content: space-between;

          .text-total-courses{
            color: $neutralBlack;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
          }
          .value-total-courses{
            color: $neutral70;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; 
          }
          .text-discount{
            color: #0F8047;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }
          .value-discount{
            color: #0F8047;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 16px;
          }
          .text-total{
            color: $neutralBlack;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
          }
          .value-total{
            color: $neutral70;
            text-align: right;
            font-family: 'Poppins-Bold', sans-serif;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 28px; 
          }

        }

        .recta{
          margin: 24px 0;
          width: 100%;
          border: 1px solid #CACBCE;
        }

      }
    }

    .total-grey{
      display: flex;
      padding: 16px;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      border-radius: 8px;
      background: $neutral05;
      margin-bottom: 32px;

      .key{
        color: $neutralBlack;
        font-family: 'Poppins-Regular', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; 
      }

      .value{
        color: $neutral70;
        font-family: 'Poppins-Bold', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
      }
    }

    .links{
      width: 100%;
      display: flex;
      flex-direction: column;

      .link{
        width: 100%;
        display: flex;
        img{
          margin-right: 8px;
        }

        a{
          color:  #592466 !important;
          font-family: 'Poppins-Medium', sans-serif !important;
          font-size: 14px !important;
          font-style: normal;
          font-weight: 500 !important;
          line-height: 22px !important; 
        }
      }

    }

    .content-button{
      margin-top: 32px;
    }
  }

  .div-alinear{
    display: flex;
    gap: 40px;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    @media (min-width: 769px) {
      flex-direction: row;
    }
    .item{
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 50%;
      }
    }
  }

  .custom-padding{
    @media (max-width: 768px) {
      padding: 0 24px;
    }
    @media (min-width: 769px) {
      padding: 0 76px;
    }
  }

  .seccion-separator{
    width: 100%;
    @media (max-width: 768px) {
      margin-top: 32px;
    }
    @media (min-width: 769px) {
      margin-top: 40px;
    }
  }
</style>

<style scoped lang="scss">
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.overlay-white {
  background: #fff;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 10000;
}

.check-in-step-1-content {
  padding: 25px 0 56px;
  @include media-breakpoint-down(sm) {
    padding-top: 0;
    padding-bottom: 140px;
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;
  }
  .row {
    display: flex;
    justify-content: flex-end;
  }
  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.download-files {
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    img {
      margin-right: 5px;
    }
  }
}

.info-collected {
  .info-collected-item {
    margin-bottom: 20px;

    span {
      font-size: 16px;
      line-height: 22px;
      @include alternative-light-regular;
    }

    p {
      @include alternative-regular;
      margin-bottom: 0;
      color: #000;
    }
  }
}

.pdv-form-group {
  p {
    font-size: 16px;
    line-height: 22px;
    @include alternative-light-regular;
  }
}

.message-info-box {
  margin-bottom: 17px;

  img {
    width: 30px;
  }

  h5 {
    @include alternative-regular;
  }

  p {
    margin-bottom: 0;

    span {
      @include alternative-medium-regular;
      font-size: 14px;
    }
  }

  @include media-breakpoint-down(sm) {
    margin: 0 -15px 17px;
  }
}

h4 {
  font-size: 18px;
  line-height: 26px;
  @include alternative-regular;
  margin-bottom: 0;
  color: $gray-dark;
}

.step-title {
  margin-bottom: 28px;

  h3 {
    font-size: 20px;
    @include alternative-bold;
    line-height: 23px;
    margin-bottom: 0;
  }

  p {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 0;
    color: $gray-dark;
  }
}

.check-box-text {
  span {
    @include alternative-light-regular;
    margin-right: 5px;
    line-height: 20px;
  }

  a {
    font-size: 13px;
    line-height: 20px;
    @include alternative-medium-regular;
  }
}

.btn-pdv-primary {
  width: 100%;
  text-align: center;
  margin: 40px 0;
}

.check-in-info {
  padding: 5px;
  .check-in-info-card {
    background: $gray-lighter;
    padding: 27px;
    margin-bottom: 20px;

    .number-student-tag {
      letter-spacing: 2px;
      font-size: 12px;
      line-height: 22px;
      margin-bottom: 22px;
      @include alternative-regular;
      color: $gray;
      display: inline-block;
    }

    .price-info-header {
      button {
        width: 100%;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;

        span:last-child {
          font-size: 24px;
          line-height: 25px;
        }

        &:focus {
          outline: none;
        }
      }
    }

    ul {
      padding-left: 0;
      margin-bottom: 0;

      li {
        display: flex;
        justify-content: space-between;
        list-style: none;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          font-size: 14px;
          @include alternative-light-regular;

          .index-number {
            font-size: 16px;
            @include alternative-medium-regular;
          }

          &:last-child {
            text-align: right;
          }
        }

        &.heading-info {
          span {
            @include alternative-medium-regular;
            font-size: 16px;
          }
        }

        &.promo-info-item {
          span {
            color: $green;
            font-size: 16px;
            @include alternative-medium-regular;
          }
        }
      }
    }

    .main-info {
      padding-bottom: 38px;
      margin-bottom: 16px;
      border-bottom: 1px solid $gray-light;

      .info-item > span:last-child {
        @include alternative-regular;
        color: #000;
      }

      &.payment-info {
        border-bottom: none;
        padding-bottom: 0;
      }
    }

    .price-info {
      margin-top: 8px;
      padding-top: 10px;
      border-top: 1px dashed;
    }
  }

  .final-price-box {
    background: $yellow-lighter;
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;

    span {
      font-size: 18px;
      line-height: 26px;
      @include alternative-bold;
      color: #000;

      &:last-child {
        font-size: 24px;
        line-height: 20px;
        @include alternative-medium-regular;
      }
    }
  }
}
</style>
